import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser'
import { BaseViewComponent } from '../base-view.component';
import { StateChangedModel } from '../../common/services/state.service';
import { FPVDataModel, SecureDataService } from '../../common/services/securedata.sevice';
import { take } from 'rxjs';
import { LanguageStateService } from '../../common/services/language-state.service';

@Component({
    selector: 'app-first-party-verification',
    templateUrl: './first-party-verification.component.html',
    styleUrl: './first-party-verification.component.scss',
    standalone: false
})
export class FirstPartyVerificationComponent extends BaseViewComponent {

  #secureDataService: SecureDataService = inject(SecureDataService)
  languageService: LanguageStateService = inject(LanguageStateService)
  fb: FormBuilder = inject(FormBuilder);
  sanitizer = inject(DomSanitizer);
  isSubmitVisible = false;
  isEditOrdertVisible = false;
  isCancelVisible = false;
  pageForm: FormGroup | undefined;

  protected override refreshView(): void {
    this.pageForm = this.fb.group({
      fpvControls: this.fb.array([]),
      comments: []
    });
  }

  protected override onSecureDataChanged(val: StateChangedModel): void {
    if (val.Type == 'FPVInfo' && val.Data != undefined) {
      const rawData = val.Data;
      if (rawData) {
        const response = rawData as FPVDataModel[];
        this.populateControls(response);
      }
    }
  }

  get fpvControls(): FormArray<FormGroup> {
    return this.pageForm?.controls['fpvControls'] as FormArray;
  }

  populateControls(data: FPVDataModel[]) {
    if (data && data.length > 0 && this.fpvControls && this.fpvControls.length === 0) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        const itemFormGroup = this.fb.group({
          Checked: [null, Validators.requiredTrue],
          Header: element.Header,
          ItemHtml: element.ItemHtml,
          Seq: element.Seq
        });
        this.fpvControls.push(itemFormGroup);
      }
    }
  }

  onFormSubmit() {
    if (this.pageForm?.valid) {
      this.isSubmitVisible = true;
    } else {
      this.pageForm?.markAllAsTouched();
      this.scrollToInvalidControl();
    }
  }

  onEditForm() {
    this.isEditOrdertVisible = true;
  }

  onFormCancel() {
    this.isCancelVisible = true;
  }

  onSubmit(isSubmitted: boolean) {
    this.isCancelVisible = false;
    this.isEditOrdertVisible = false;
    this.isSubmitVisible = false;
    const data = {
      form: this.pageForm?.value,
      isSubmitted: isSubmitted
    }
    this.#secureDataService.submitCustomerData(data, 'FPVInfo')
      .subscribe({
        next: () => {
          this.navigateWaiting();
        },
        error: (err) => {
          this.notificationService.showError(err);
        }
      });
  }

  onPopupCancel() {
    this.isCancelVisible = false;
    this.isEditOrdertVisible = false;
    this.isSubmitVisible = false;
  }

  onPopupSubmit(data: unknown) {
    if (data && (data as { data: { success: boolean } }).data?.success) {
      this.onSubmit(true);
    } else {
      this.onPopupCancel();
    }
  }

  onPopupEdit(data: unknown) {
    if (data && (data as { data: { success: boolean } }).data?.success) {
      this.onSubmit(false);
    } else {
      this.onPopupCancel();
    }
  }
  onCancel(data: unknown) {
    if (data && (data as { data: { success: boolean } }).data?.success) {
      this.#secureDataService.cancel('FPVInfo').pipe(take(1)).subscribe(
        {
          next: () => {
            this.navigateWaiting(true);
          },
          error: (err) => this.onCancelError('FPVInfo', err)
        })
    } else {
      this.onPopupCancel();
    }
  }

  override sendCustomerInputMessage(message: string, setPrefix: boolean = true): void {
    const data = `${setPrefix ? 'Customer is attempting ' : ''}${message}.`;
    this.sendSignalRAlert(data);
  }

  sendCustomerAlertMessage(model: FPVDataModel) {
    this.sendCustomerInputMessage(`${model.Header} checkbox`);
  }
}